export default "__VITE_ASSET__becf2a94__"